import { render } from "./dashboard-preview-modal.vue?vue&type=template&id=bcf20d18&ts=true"
import script from "./dashboard-preview-modal.ts?vue&type=script&lang=ts&external"
export * from "./dashboard-preview-modal.ts?vue&type=script&lang=ts&external"

import "./dashboard-preview-modal.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__